import { render, staticRenderFns } from "./VCover.vue?vue&type=template&id=9b1b79b4&"
import script from "./VCover.vue?vue&type=script&lang=js&"
export * from "./VCover.vue?vue&type=script&lang=js&"
import style0 from "./VCover.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports